import { useEffect, useRef } from "react";

const MAX_SIZE = 24;
const MIN_SIZE = 8;

const activateChristmasSpirit = (canvas: HTMLCanvasElement) => {
  const ctx = canvas.getContext("2d");
  if (!ctx) {
    return;
  }

  const maxNumberOfSnowflakes = window.innerWidth/3;
  const array: { x: number, y: number, size: number, speedX: number, speedY: number, rotation: number, remove: boolean }[] = [];
  for (let i = 0; i < maxNumberOfSnowflakes; i++) {
    const size = Math.floor(Math.random() * (MAX_SIZE - MIN_SIZE) + MIN_SIZE);
    array.push({
      x: Math.floor(Math.random() * window.innerWidth),
      y: Math.floor(Math.random() * window.innerHeight),
      size,
      speedX: (Math.random() - 0.5) * 2 * size/MAX_SIZE,
      speedY: Math.random() + (2) * size/MAX_SIZE,
      rotation: Math.floor(Math.random() * (120) - 60),
      remove: false,
    });
  }

  const drawRotatedImage = (img: HTMLImageElement, size: number, x: number, y: number, angleRad: number) => {
    ctx.save();
    ctx.translate(x, y);
    ctx.rotate(angleRad);
    ctx.fillStyle = "white";
    ctx.drawImage(img, -size/2, -size/2, size, size);
    ctx.restore();
  };

  const img = new Image();

  const draw = () => {
    const rect = canvas.getBoundingClientRect();
    const dpr = window.devicePixelRatio || 1;

    canvas.width  = rect.width  * dpr;
    canvas.height = rect.height * dpr;

    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    ctx.clearRect(0, 0, window.innerWidth, window.innerHeight);
    const isGrinch  = window.localStorage.getItem('isGrinch') === "true";
    if (!isGrinch) {
      for (let i = 0; i < array.length; i++) {
        array[i].x += array[i].speedX;
        array[i].y += array[i].speedY;
        if (array[i].y > window.innerHeight || array[i].y < 0 || array[i].x > window.innerWidth || array[i].x < 0) {
          array[i].y = 0;
          array[i].x = Math.floor(Math.random() * window.innerWidth);
        }

        const angle = array[i].rotation * Math.PI / 180;
        drawRotatedImage(img, array[i].size, array[i].x, array[i].y, angle);
      }
    }

    setTimeout(() => {
      window.requestAnimationFrame(draw);
    }, 1000 / 60);
  }

  img.onload = function() {
    window.requestAnimationFrame(draw);
  }
  img.src = "/snowflake.svg";
}

export const isDecemberOrBeforeJan7th = () => {
  return (new Date().getMonth() == 11 || (new Date().getMonth() == 0 && new Date().getDate() < 7));
}

export const ChristmasSpirit = () => {
  const canvas = useRef<HTMLCanvasElement>(null);

  useEffect(() => {
    if (canvas.current && isDecemberOrBeforeJan7th()) {
      activateChristmasSpirit(canvas.current);
    }
  }, [canvas]);

  return (
    <canvas ref={canvas} style={{ width: '100%', height: '100%', display: "block", position: 'fixed', top: 0, left: 0, pointerEvents: 'none' }} />
  )
}